import { ReactNode } from "react";
import { useTranslation } from "next-i18next";
import Link from "next/link";
import Image from "next/image";
import Pagination from "@/src/shared/Pagination";
import DateTimeHelper from "@/src/utils/helpers/DateTimeHelper";
import useBrowserRoutes from "@/src/utils/helpers/useBrowserRoutes";
import { useAnnouncementsPageContext } from "@/src/features/announcements/AnnouncementsPageContext";

const AnnouncementsGridSection = (): ReactNode => {
  const routes = useBrowserRoutes();
  const { items, totalPages, currentPage } = useAnnouncementsPageContext();
  const { t } = useTranslation();

  return (
    <>
      <div className="row g-5">
        {items.map(item => {
          const detailLink = routes.announcementDetail.replace(":slug", item.Slug);

          return (
            <div className="col-lg-4 col-md-6 col-12" key={item.IdGuid}>
              <div className="rbt-card event-grid-card variation-01 rbt-hover d-flex flex-column">
                <div className="rbt-card-img">
                  <Link href={detailLink}>
                    <Image
                      src={item.ThumbImageUrl}
                      width={355}
                      height={240}
                      priority
                      alt={item.ImageAltText}
                      style={{
                        objectFit: "cover",
                        height: 240
                      }}
                    />
                  </Link>
                </div>
                <div className="rbt-card-body d-flex flex-column flex-fill">
                  <ul className="rbt-meta">
                    <li>{item.Category.Name}</li>
                    <li>
                      <i className="feather-calendar"></i>
                      {DateTimeHelper.toDisplayDateTime(item.CreatingDateTime, "D MMMM, YYYY")}
                    </li>
                  </ul>
                  <h4 className="rbt-card-title">
                    <Link href={detailLink}>{item.Title}</Link>
                  </h4>
                  <div className="read-more-btn mt-auto">
                    <Link className="rbt-btn btn-border hover-icon-reverse btn-sm radius-round" href={detailLink}>
                      <span className="icon-reverse-wrapper">
                        <span className="btn-text">{t("programDetails")}</span>
                        <span className="btn-icon">
                          <i className="feather-arrow-right"></i>
                        </span>
                        <span className="btn-icon">
                          <i className="feather-arrow-right"></i>
                        </span>
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
      <div className="row">
        <div className="col-lg-12 mt--60">
          <Pagination totalPages={totalPages} currentPage={currentPage} route={routes.programs} />
        </div>
      </div>
    </>
  );
};

export default AnnouncementsGridSection;
